import { useEffect, useState } from "react";

export function useBreakpoint() {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setWidth(window.innerWidth);

      const callback = () => setWidth(window.innerWidth);

      window.addEventListener("resize", callback);

      return () => window.removeEventListener("resize", callback);
    }
  }, []);

  return { width };
}
